import React from "react";
import {
  Box,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  HStack,
  VStack,
} from "@chakra-ui/react";
import ReactPlayer from "react-player";

export default function Clip({ clip }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClick = () => {
    onOpen();
  };

  // Extract clip data from the API response structure
  const clipName = clip.filename || "Untitled Clip";
  const videoUrl = clip.url;

  return (
    <>
      <Box
        _hover={{ shadow: "md" }}
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
        cursor="pointer"
        mb={3}
        onClick={handleClick}
        overflow="hidden"
        transition="all 0.2s"
      >
        <Box p={2}>
          <VStack align="start" spacing={1}>
            <Text fontSize="sm" fontWeight="medium" noOfLines={1}>
              {clipName}
            </Text>
            <HStack spacing={2}>
              <Text color="gray.500" fontSize="xs">
                {clip.size_mb}
              </Text>
              <Text color="gray.500" fontSize="xs">
                {clip.extension?.toUpperCase()}
              </Text>
            </HStack>
          </VStack>
        </Box>
      </Box>

      {/* Video Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{clipName}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={4}>
              <ReactPlayer controls height="auto" url={videoUrl} width="100%" />
              <HStack color="gray.600" fontSize="sm" spacing={4}>
                <Text>Size: {clip.size_mb}</Text>
                <Text>Format: {clip.extension?.toUpperCase()}</Text>
                <Text>
                  Modified: {new Date(clip.last_modified).toLocaleDateString()}
                </Text>
              </HStack>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
